"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPanelSectionView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const Title = (0, app_1.styled)(app_1.Text) `
  font-size: 1.375rem;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: 0.009375rem;
  color: #000000;
`;
const StackPadding = (0, app_1.styled)(ui_1.Stack) `
  padding: 0 ${(theme) => theme.spacing.small};
`;
function UserPanelSectionView({ title, children, }) {
    return ((0, jsx_runtime_1.jsxs)(StackPadding, Object.assign({ kind: "vertical", spacing: "small" }, { children: [(0, jsx_runtime_1.jsx)(Title, Object.assign({ tag: "h1" }, { children: title })), children] })));
}
exports.UserPanelSectionView = UserPanelSectionView;
